interface LoadingSpinnerProps {
  text?: string;
  size?: "sm" | "md" | "lg";
}

export function LoadingSpinner({ text, size = "md" }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  const textMarginClasses = {
    sm: "mt-2",
    md: "mt-2",
    lg: "mt-4",
  };

  const textSizeClasses = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
  };

  return (
    <div className="text-center">
      <div
        className={`inline-block animate-spin rounded-full border-2 border-[var(--stroke-field)] border-t-[var(--text-primary)] ${sizeClasses[size]}`}
      ></div>
      {text && (
        <p
          className={`${textMarginClasses[size]} ${textSizeClasses[size]} text-[var(--text-secondary)]`}
        >
          {text}
        </p>
      )}
    </div>
  );
}
